/**
 * Decode Euler uint16 cap encoding directly to BigInt.
 * Format: 6 LSBs = exponent, 10 MSBs = mantissa integer (divided by 100 implicitly).
 * Value = (mantissaInt / 100) * 10^exponent = mantissaInt * 10^(exponent - 2)
 *
 * Computing entirely in BigInt avoids floating-point precision loss for large caps.
 */
export function decodeEulerCapToBigInt(encodedValue: number | undefined): bigint | undefined {
  if (!encodedValue) return undefined

  const exponent = encodedValue & 0x3f
  const mantissaInt = encodedValue >> 6

  if (mantissaInt === 0) return undefined

  if (exponent >= 2) {
    return BigInt(mantissaInt) * 10n ** BigInt(exponent - 2)
  }

  if (exponent === 1) {
    return BigInt(mantissaInt) / 10n
  }

  return BigInt(mantissaInt) / 100n
}
